import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {FullComponent} from './layouts/full/full.component';
import {BlankComponent} from './layouts/blank/blank.component';
import {AuthGuardService} from './shared/services/auth-guard.service';
import {PreviewEtudeComponent} from './modules/preview-etude/preview/preview-etude.component';
import {RedirectLinksModule} from './modules/redirect-links/redirect-links.module';

// @ts-ignore
export const AppRoutes: Routes = [
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuardService],
    children: [
      {path: '', redirectTo: '/dashboard/dashboardoperationpublic', pathMatch: 'full'},
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboards/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'ai-agent/results',
        loadChildren:
          () => import('./modules/ai-agent/results/ai-agent-results.module').then(m => m.AiAgentResultsModule)
      },
      {
        path: 'starter',
        loadChildren: () => import('./starter/starter.module').then(m => m.StarterModule)
      },
      {
        path: 'component',
        loadChildren: () => import('./component/component.module').then(m => m.ComponentsModule)
      },
      {path: 'icons', loadChildren: () => import('./icons/icons.module').then(m => m.IconsModule)},
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren:
          () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule)
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'crowdsourcing',
        loadChildren:
          () => import('./modules/crowd-sourcing/crowed-sourced.module').then(m => m.CrowedSourcedModule)
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'consent',
        loadChildren:
          () => import('./consent_form/consentForm.module').then(m => m.ConsentFormModule)
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'ai-agent',
        loadChildren:
          () => import('./modules/ai-agent/ai-agent.module').then(m => m.AiAgentModule)
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'redirect-links',
        loadChildren:
          () => import('./modules/redirect-links/redirect-links.module').then(m => m.RedirectLinksModule)
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'whiteboard/:id',
        loadChildren:
          () => import('./modules/whiteboard/whiteboard.module').then(m => m.WhiteboardModule)
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'consent',
        loadChildren:
          () => import('./consent_form/consentForm.module').then(m => m.ConsentFormModule)
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'consentform/:id',
        loadChildren:
          () => import('./consentform/consentform.module').then(m => m.ConsentformModule)
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'preview',
        loadChildren:
          () => import('./modules/preview-etude/preview-etude.module').then(m => m.PreviewEtudeModule)
      }
    ]
  },
  {
    // Runner d'interview : pleine fenêtre, sans le layout du tableau de bord.
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'interview-runner',
        loadChildren:
          () => import('../looka/features/surveys/surveys.module').then(m => m.SurveysModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/authentication/404'
  },
  {
    path: '**',
    redirectTo: '/dashboard/a_propos'
  },
  {
    path: '**',
    redirectTo: '/dashboard/confidentialite'
  },
  {
    path: '**',
    redirectTo: '/dashboard/faq'
  },
  {
    path: 'questions',
    redirectTo: '/dashboard/f'
  }
];
